// extracted by mini-css-extract-plugin
export default {"title-section":"_91Ih+H4HBr","titleSection":"_91Ih+H4HBr","tabs":"UFDTR-+MkT"};